module.exports = __webpack_public_path__ + "static/media/scuba_diver.333f1c02.svg";